<template lang="pug">
    .otto-market-keys(v-if="k >= 0")
        h4
            i.el-icon-fa-store.fas
            | {{ $t('Otto Market') }}
        el-form-item(:label="$t('Client ID')")
            el-input(type="input" v-model="public" maxlength="255" show-word-limit)
        el-form-item(:label="$t('Secret Key')")
            el-input(type="input" v-model="private" maxlength="255" show-word-limit)
</template>

<script>
import _ from 'lodash'
import { useSettingsStore, useCmsWizardStore } from '@/stores'

export default {
    name: 'OttoMarketKeys',
    props: {
        cms: {
            type: Object,
            required: true,
        },
        storeModule: {
            type: String,
            default: 'settings/form',
        },
    },
    data() {
        return {
            key: 'otto-market-keys',
        }
    },
    computed: {
        isWizardMode() {
            return this.storeModule === 'cmsWizard';
        },
        k() {
            const apiKeys = _.get(this.cms, 'apiKeys') || []
            return _.findIndex(apiKeys, apiKey => apiKey.key === this.key)
        },
        public: {
            get() {
                return _.get(this.cms, `apiKeys.${this.k}.public`, '')
            },
            set(value) {
                const data = {
                    index: this.k,
                    field: 'public',
                    value
                }
                if (this.isWizardMode) {
                    useCmsWizardStore().cmsApiKey(data);
                } else {
                    useSettingsStore().setFormCmsApiKey(data);
                }
            }
        },
        private: {
            get() {
                return _.get(this.cms, `apiKeys.${this.k}.private`, '')
            },
            set(value) {
                const data = {
                    index: this.k,
                    field: 'private',
                    value
                }
                if (this.isWizardMode) {
                    useCmsWizardStore().cmsApiKey(data);
                } else {
                    useSettingsStore().setFormCmsApiKey(data);
                }
            }
        },
    },
    mounted() {
        if (this.k < 0) {
            if (this.isWizardMode) {
                useCmsWizardStore().addCmsApiKey(this.key);
            } else {
                useSettingsStore().addFormCmsApiKey(this.key);
            }
        }
    }
}
</script>

<style lang="sass" scoped>
    .otto-market-keys
        padding-left: 12px
        position: relative
        &:before
            content: ''
            position: absolute
            left: 0
            top: 0
            bottom: 0
            width: 4px
            background: rgba($color-grey-text, .2)
            border-radius: 6px
        h4
            color: $color-grey-text
</style>
